import { render } from "./IFSOrderDownload.vue?vue&type=template&id=55943632&scoped=true"
import script from "./IFSOrderDownload.vue?vue&type=script&lang=js"
export * from "./IFSOrderDownload.vue?vue&type=script&lang=js"

import "./IFSOrderDownload.vue?vue&type=style&index=0&id=55943632&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55943632"]])

export default __exports__